import { createSlice } from "@reduxjs/toolkit";



const CommonHelperSlice = createSlice({
    name: "user",
    initialState: {
        propertyCategories: {},
    },
    reducers: {
        setPropertyCategories(state, action) {
            state.propertyCategories = action.payload;
        },
    },

});
export const { setPropertyCategories } = CommonHelperSlice.actions;

export default CommonHelperSlice.reducer;
